import { type ReactNode, useState } from 'react'
import { type Champ, Formulaire } from './Formulaire'
import { Icone } from './Icone'

/**
 * Valeur de fiche modifiable sur place : le crayon remplace la valeur par sa saisie, Entrée
 * enregistre, Échap annule. Sans droit d'écriture, la valeur seule.
 */
export function EnLigne({
  libelle,
  champs,
  initial,
  modifiable,
  onEnregistrer,
  children,
}: {
  libelle: string
  champs: Champ[]
  initial: Record<string, unknown>
  modifiable: boolean
  onEnregistrer: (valeurs: Record<string, unknown>) => Promise<unknown>
  children: ReactNode
}) {
  const [edite, setEdite] = useState(false)
  if (!modifiable) return <>{children}</>
  if (edite)
    return (
      <Formulaire
        enLigne
        champs={champs}
        initial={initial}
        onAnnuler={() => setEdite(false)}
        onValider={async (v) => {
          await onEnregistrer(v)
          setEdite(false)
        }}
      />
    )
  return (
    <div className="en-ligne">
      <div className="en-ligne-valeur">{children}</div>
      <button
        type="button"
        className="en-ligne-crayon"
        title={`Modifier : ${libelle}`}
        aria-label={`Modifier : ${libelle}`}
        onClick={() => setEdite(true)}
      >
        <Icone nom="edit" />
      </button>
    </div>
  )
}
